export default "__VITE_ASSET__Bk8IBR8H__"